import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  siteLabel: {
    id: 'linkCreate.CreateConfluencePage.form.site.label',
    defaultMessage: 'Site',
    description: 'Label for the Site dropdown list'
  }
});